import { Box, Heading } from '@chakra-ui/react';
import React from 'react';
import AgendaWrapper from '@/components/agenda/AgendaWrapper';
import EventCard, { IAgendaEvent } from '@/components/agenda/EventCard';

interface Props {
  events?: IAgendaEvent[];
}

const EventAgenda: React.FC<Props> = ({ events }) => (
  <Box mt={{ xs: '24px', lg: '28px' }}>
    {events && events.length > 0 && (
      <Heading
        color="secondaryPurple.900"
        fontSize={{ xs: '24px', lg: '34px' }}
        fontWeight="700"
        lineHeight="130%"
        textAlign="center"
      >
        Agenda
      </Heading>
    )}
    <Box px={{ xs: '0', lg: '90px' }}>
      <AgendaWrapper>
        {events &&
          events.length > 0 &&
          events.map((item) => <EventCard key={item.id} event={item} />)}
      </AgendaWrapper>
    </Box>
  </Box>
);

export default EventAgenda;
